import { create } from 'zustand';

export interface BlockModalConfig {
  title?: string;
  content?: string;
}


export const useDrawerState = create<{
  isDrawerEditing: boolean;
  blockModalConfig: BlockModalConfig;
  setIsDrawerEditing: (isEditing: boolean, blockModalConfig?: BlockModalConfig) => void;
}>((set) => ({
  isDrawerEditing: false,
  blockModalConfig: {},
  setIsDrawerEditing: (isEditing, blockModalConfig) => {
    set({ isDrawerEditing: isEditing, blockModalConfig: blockModalConfig || {} })
  }
}));

